import { $t } from '../../composables/i18n'
import { Codebook } from '../Codebook'

export enum LeadOriginId {
  WEB_FORM = 'web-form',
  OWN_ACQUISITION = 'own-acquisition',
  PMS = 'pms',
}

export class LeadOrigin extends Codebook<LeadOriginId> {
  static readonly WEB_FORM = new LeadOrigin(LeadOriginId.WEB_FORM, () => $t('Web form'))
  static readonly OWN_ACQUISITION = new LeadOrigin(LeadOriginId.OWN_ACQUISITION, () =>
    $t('Own acquisition'),
  )
  static readonly PMS = new LeadOrigin(LeadOriginId.PMS, () => $t('PMS'))

  private constructor(
    id: LeadOriginId,
    public readonly name: () => string,
  ) {
    super(id)
  }
}
